import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  createPageData,
  sparePartRequestFormData,
} from "./SparePartRequestFile.js";

import { AvForm } from "availity-reactstrap-validation";
import { formatDate, getRecords } from "../../services/api.service.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { LoaderCreatePage } from "../Loader/Loader.js";

const SparePartRequestView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(sparePartRequestFormData());
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    try {
      const payload = {
        modelName: "spare_part_requests",
        schema: initialPayload?.schema,

        include: [
          {
            model: "job_cards",
            as: "job_card",
          },
          {
            model: "material_masters",
            as: "spare",
          },
          {
            model: "user_masters",
            as: "requested_by_user",
          },
          {
            model: "spare_part_issues",
            as: "issues",
          },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Spare Part Requests Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Job Card: </strong>
                                {formData?.inputData?.job_card?.job_card_no ||
                                  "-"}
                              </p>
                              <p>
                                <strong>SPARE PART: </strong>
                                {formData?.inputData?.spare?.name || "-"}
                              </p>
                              <p>
                                <strong>Quantity: </strong>
                                {formData?.inputData?.quantity || "-"}
                              </p>

                              <p>
                                <strong>Issue Qty: </strong>
                                {formData?.inputData?.issue_qty || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.status || "-"}
                              </p>
                              <p>
                                <strong>Requested By: </strong>
                                {formData?.inputData?.requested_by_user
                                  ?.first_name || "-"}{" "}
                                {formData?.inputData?.requested_by_user
                                  ?.last_name || "-"}
                              </p>
                              <p>
                                <strong>Requested At: </strong>
                                {formatDate(
                                  formData?.inputData?.requested_at
                                ) || "-"}
                              </p>

                              <p>
                                <strong>Is Active: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SparePartRequestView;
